import React from 'react';
import { Link } from 'react-router-dom';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-2xl mx-auto px-6">
        <div className="bg-white rounded-xl shadow-lg p-8 text-center">
          
          {/* Icon */}
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-amber-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>

          {/* Content */}
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Your payment was cancelled and no charges were made to your account.
          </p>

          {/* What you missed */}
          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-gray-800 mb-4">What You Would Have Received</h3>
            <ul className="text-left space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="text-gray-700">Complete professional ESA report with detailed recommendations</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="text-gray-700">Industry-specific RECC opportunities analysis</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="text-gray-700">Implementation roadmaps and priority rankings</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="text-gray-700">Partner connections and funding opportunities</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span className="text-gray-700">48-hour delivery with 90-day money-back guarantee</span>
              </li>
            </ul>
          </div>

          {/* Action buttons */}
          <div className="space-y-4">
            <Link
              to="/payment/checkout"
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold inline-block transition-colors"
            >
              Complete Payment - $990 AUD
            </Link>
            
            <div className="flex items-center justify-center gap-8">
              <Link
                to="/sample-esa-report"
                className="text-emerald-600 hover:text-emerald-700 font-medium"
              >
                View Sample Report
              </Link>
              <span className="text-gray-300">•</span>
              <Link
                to="/"
                className="text-emerald-600 hover:text-emerald-700 font-medium"
              >
                Return to Home
              </Link>
            </div>
          </div>

          {/* Still have questions */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h4 className="font-semibold text-gray-800 mb-2">Still Have Questions?</h4>
            <p className="text-sm text-gray-600">
              Our team is here to help. Contact us at{' '}
              <a 
                href="mailto:info@relyability.ai" 
                className="text-emerald-600 hover:text-emerald-700"
              >
                info@relyability.ai
              </a>
              {' '}or see our sample report to understand the value.
            </p>
          </div>

          {/* Customer testimonial */}
          <div className="mt-8 bg-emerald-50 border border-emerald-200 rounded-lg p-6">
            <p className="text-emerald-800 italic text-sm">
              "The analysis was incredibly detailed and gave us a clear roadmap to reduce our energy costs. 
              We're already seeing the projected savings."
            </p>
            <p className="text-emerald-600 text-xs mt-2 font-medium">
              — Operations Manager, Major Food Manufacturer
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500">
            Questions about our reports? Contact{' '}
            <a href="mailto:info@relyability.ai" className="text-emerald-600 hover:text-emerald-700">
              info@relyability.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;